const Accountant = () =>
  import(
    /* webpackChunkName: "Accountant" */ '@/view/pages/accountant/Accountant.vue'
  );
const ListAccountant = () =>
  import(
    /* webpackChunkName: "ListAccountant" */ '@/view/pages/accountant/list/ListAccountant.vue'
  );
const AddAccountantPage = () =>
  import(
    /* webpackChunkName: "AddAccountantPage" */ '@/view/pages/accountant/add/AddAccountantPage.vue'
  );
const UpdateAccountantPage = () =>
  import(
    /* webpackChunkName: "UpdateAccountant" */ '@/view/pages/accountant/update/UpdateAccountant.vue'
  );
import InstallmentCategoryRoutes from './installment-category';
import TransactionRouters from '../view/pages/transaction/routers';

export default [
  {
    path: '/accounting',
    component: Accountant,
    children: [
      {
        path: 'accounts',
        name: 'list-accountant',
        component: ListAccountant,
        meta: {
          title: 'Danh sách tài khoản kế toán - ClickBuy',
        },
      },
      {
        path: 'accounts/add',
        name: 'add-accountant',
        component: AddAccountantPage,
        meta: {
          title: 'Thêm mới tài khoản kế toán - ClickBuy',
        },
      },
      {
        path: 'accounts/update/:id',
        name: 'update-accountant',
        component: UpdateAccountantPage,
        meta: {
          title: 'Cập nhật tài khoản kế toán - ClickBuy',
        },
        props: true,
      },
      ...InstallmentCategoryRoutes,
      ...TransactionRouters,
    ],
  },
];
